import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { path, sidebar } from '../../constants';
import HeaderLogo from '../../assets/images/logo1.png';
import './SideBar.scss';
import { MainLogo } from '../../assets/svg';
import { useDefaultContext } from '../../contexts/UserContext';

export default function SideBar() {
  const location = useLocation();
  const {user} =useDefaultContext()
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>('personal-info');

  useEffect(() => {
    const matchedPath= sidebar.sideBarPathList.find(sidePath => location.pathname.startsWith(sidePath));
    if (matchedPath) {
      setActiveTab(matchedPath);
    }
  }, [location.pathname]);

  const handleLogoClick = () => {
    navigate(path.PERSONAL_INFO);
  }
  return (
    <div className="sidebar">
      <div className="pointer" onClick={handleLogoClick}>
        <img alt="logo" src={MainLogo} className="logo" />
      </div>
      <div className="sidebar-content-wrapper">
        {sidebar.list.map((item, index) => {
          const isSelected = activeTab === item.path;
          const Icon = item.icon;
         return item?.newTab ?
         <>
         {
          !user?.isSuperAdmin &&
         <div onClick={()=>(!user?.isSuperAdmin&&  window.open(`${process.env.REACT_APP_PORTAL_URL}credit?access_token=${localStorage.getItem('access_token')}&refresh_token=${localStorage.getItem('refresh_token')}&redirectURL=${process.env.REACT_APP_FRONTEND_BASE_URL}`,'_blank'))}  className="d-flex align-items-center justify-content-start sidebar-link credit-link">
          <Icon active={isSelected} />
              <span className="sidebar-items">{item.name}</span>
          </div>
         }
         </>
          :          
            <Link to={item.path} className={`sidebar-link ${isSelected ? 'active' : ''}`} target={item.target} key={index}>
              <div  className="d-flex align-items-center justify-content-center"><Icon active={isSelected} /></div>
              <div className="sidebar-items">{item.name}</div>
            </Link>
      
        })}
      </div>
    </div>
  );
}
